import { SliceErrorState } from '@/store/slices/sliceError';

export type UserAccountSettings = {
  accountID?: string;
  username?: string;
  firstName?: string;
  lastName?: string;
  countryCode?: string;
  lastLoginDate?: string | null;
  [key: string]: unknown;
};

export type UserContextData = {
  accountSettings?: UserAccountSettings;
  [key: string]: unknown;
};

/** Domain payload (mirrors GeolocationContext). */
export type UserContext = {
  data: UserContextData | null;
};

/** Status flags (mirrors GeolocationStatus). */
export type UserStatus = {
  loading: boolean;
};

export enum UserStoreParts {
  userContext = 'userContext',
  userStatus = 'userStatus',
  /** Named userError so RootState keeps geolocation `error` separate */
  userError = 'userError',
}

export type UserContextPayload = Partial<UserContext>;
export type UserStatusPayload = Partial<UserStatus>;
export type UserErrorPayload = Partial<SliceErrorState>;

export type UserContextSlice = {
  userContext: UserContext;
  userContextStatus: UserStatus;
  userContextError: SliceErrorState;

  setUserContext: (newState: UserContextPayload) => void;
  setUserContextStatus: (newState: UserStatusPayload) => void;
  setUserContextError: (newState: UserErrorPayload) => void;
  resetUserContextPart: (part: UserStoreParts) => void;
  resetAllUserContextParts: () => void;
};
